import { render, staticRenderFns } from "./project-header.vue?vue&type=template&id=4586cd7f"
import script from "./project-header.vue?vue&type=script&lang=ts"
export * from "./project-header.vue?vue&type=script&lang=ts"
import style0 from "./project-header.vue?vue&type=style&index=0&id=4586cd7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports